module.exports = __webpack_public_path__ + "static/media/condenser-03.cbeeae09.png";